import { FC } from "react";
import { useTranslation } from "react-i18next";
import { MainSearch } from "src/Modules/Hotels/Components";

interface HotelSearchWebProps {
  imgUrl?: string;
}

const HotelSearchWeb: FC<HotelSearchWebProps> = ({ imgUrl }) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col items-center px-2 pt-2 px-2">
      <div className="relative w-full max-w-[97%]">
        <div
          className="relative h-[360px] w-full overflow-hidden rounded-xl bg-no-repeat bg-cover bg-center lg:h-[480px]"
          style={{ backgroundImage: `url(${imgUrl})`, backgroundPosition:"0 75%" }}
        >
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/10" />
          <div className="relative z-10 flex h-full flex-col justify-center gap-2 px-8 lg:px-12">
            <h1 className="text-start text-2xl font-bold text-white lg:text-4xl">{t("Hotels.search.heroTitle")}</h1>
            <p className="text-start text-base text-white/90 lg:text-xl">{t("Hotels.search.heroSubtitle")}</p>
          </div>
        </div>

        <div className="relative z-20 -mt-35 rounded-lg bg-white p-5 shadow-xl lg:mx-8 lg:p-7">
          <MainSearch />
        </div>
      </div>
    </div>
  );
};

export default HotelSearchWeb;
